import { render, staticRenderFns } from "./SigatokaCapture.vue?vue&type=template&id=bdfdfe20"
import script from "./SigatokaCapture.vue?vue&type=script&lang=js"
export * from "./SigatokaCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports